var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconCloseWithoutBackground = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#515a65",
    fillRule: "nonzero",
    d: "M10.867 10.002L6.698 14.04c-.288.279-.754.279-1.04 0l-.692-.672c-.288-.279-.288-.73 0-1.006L7.921 9.5 4.966 6.637c-.288-.279-.288-.73 0-1.006l.693-.672c.288-.279.754-.279 1.04 0L10.866 9c.288.272.288.724 0 1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515a65",
    fillRule: "nonzero",
    d: "M8.529 10.002l4.169 4.039c.288.279.754.279 1.039 0l.693-.672c.288-.279.288-.73 0-1.006L11.475 9.5l2.955-2.863c.288-.279.288-.73 0-1.006l-.693-.672c-.288-.279-.754-.279-1.04 0L8.53 9c-.289.272-.289.724 0 1.003z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCloseWithoutBackground, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-close-without-background.9b3b0c89.svg";
export { ForwardRef as ReactComponent };